import { render, staticRenderFns } from "./CriarPerguntas.vue?vue&type=template&id=240185ee&scoped=true&"
import script from "./CriarPerguntas.vue?vue&type=script&lang=js&"
export * from "./CriarPerguntas.vue?vue&type=script&lang=js&"
import style0 from "./CriarPerguntas.vue?vue&type=style&index=0&id=240185ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240185ee",
  null
  
)

export default component.exports